var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-wrapper"},[_vm._t("upper"),_c('el-row',{staticClass:"sub-head",attrs:{"type":"flex"}},[_c('el-col',{staticClass:"sub-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('h5',[_vm._v(_vm._s(_vm.subtitle))]),_vm._t("titleContents")],2),_vm._t("side")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }